import noticeError from "src/app/utilities/noticeError";
import { addPageAction } from "src/utilities/newrelic";
import { getSierraConfig } from "src/app/components/SierraChat/utils/getSierraConfig";

import getQueryParamValue from "src/utilities/getQueryParamValue";
import { getSierraInstance } from "src/app/components/SierraChat/utils/getSierraInstance";

export const setChatWidgetParam = () => {
  if (typeof window !== "undefined") {
    const url = new URL(window.location.href);
    url.searchParams.set("showChatWidget", "true");
    window.history.replaceState({}, "", url.toString());
  }
};

export const deleteChatWidgetParam = () => {
  if (typeof window !== "undefined") {
    const url = new URL(window.location.href);
    url.searchParams.delete("showChatWidget");
    window.history.replaceState({}, "", url.toString());
  }
};

export const sierraChatTimeoutAction = (setShow, setLoadError) => {
  return setTimeout(() => {
    const sierraChatContainer = document.querySelector(
      "#sierra-chat-container"
    );

    const sierraChatWidget =
      sierraChatContainer?.shadowRoot?.querySelector("main");

    const titleBarContent = sierraChatContainer?.shadowRoot?.querySelector(
      '[part="chat-title-bar-content"]'
    );

    const chatBotLoaded = sierraChatWidget && titleBarContent;

    if (chatBotLoaded) {
      addPageAction("sierra_chat_loaded");
    } else if (getQueryParamValue("showChatWidget")) {
      deleteChatWidgetParam();
      const timeoutError = new Error("Sierra Chat: Timeout error");
      noticeError(timeoutError);
      setShow(false);
      setLoadError(timeoutError);
    }
  }, 5000);
};

export const init = async (toggleChatModal) => {
  const sierraInstance = getSierraInstance();

  window.sierraConfig = await getSierraConfig();

  const agentScript = document.createElement("script");
  agentScript.type = "module";
  agentScript.onload = toggleChatModal;
  agentScript.src = sierraInstance;
  document.head.appendChild(agentScript);

  return () => {
    document.head.removeChild(agentScript);
  };
};
